import { Button } from '@mui/material';
import React from 'react';

function ForgotPassword() {
  return <div>
      <Button>Forgot Password</Button>
  </div>;
}

export default ForgotPassword;
